import { configureStore } from '@reduxjs/toolkit'
import { DROPDOWN_LIST, FORM, TABLE, VALIDATION } from './types'

import formSlice from '1.newComponents/form/formSlice'
import validationSlice from '1.newComponents/form/validationSlice'
import dropdownListSlice from '1.newComponents/form/dropdownListSlice'
import tableSlice from '1.newComponents/Table/tableSlice'
// import user from 'containers/login/loginSlice'
export default configureStore({
  reducer: {
    [FORM]: formSlice,
    [VALIDATION]: validationSlice,
    [DROPDOWN_LIST]: dropdownListSlice,
    [TABLE]: tableSlice
  }
})
